const ORIGIN = "https://realtyblocks.co.in";

type Crumb = { name: string; path: string };

export function buildBreadcrumbList(crumbs: Crumb[]) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: crumbs.map((c, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: c.name,
      item: ORIGIN + c.path,
    })),
  };
}

export function buildWebApplication(opts: {
  name: string;
  description: string;
  path: string;
  category?: string;
  features?: string[];
}) {
  return {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    name: opts.name,
    description: opts.description,
    url: ORIGIN + opts.path,
    applicationCategory: opts.category || "BusinessApplication",
    operatingSystem: "Web Browser",
    browserRequirements: "Requires JavaScript. Modern browsers.",
    offers: { "@type": "Offer", price: "0", priceCurrency: "INR" },
    publisher: { "@id": `${ORIGIN}/#organization` },
    inLanguage: ["en-IN", "hi-IN"],
    ...(opts.features ? { featureList: opts.features } : {}),
  };
}
